import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Stats from "@/components/Stats";

const TEXTURE_URL =
  "https://images.unsplash.com/photo-1612538498613-35c5c8d675c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxzdWJ0bGUlMjBjcmVhbSUyMHBhcGVyJTIwdGV4dHVyZSUyMG9mZiUyMHdoaXRlfGVufDB8fHx8MTc5MTg5OTI4OXww&ixlib=rb-4.1.0&q=85";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="relative min-h-screen w-full overflow-x-hidden bg-[#F7F6F2] font-body text-[#1A1F5E] antialiased">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 z-0 bg-cover bg-center opacity-40 mix-blend-multiply"
        style={{ backgroundImage: `url(${TEXTURE_URL})` }}
      />
      <Nav />
      {window.location.pathname === "/stats" ? <Stats /> : <Hero />}
    </div>
  );
}
